import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import ModernImage from "@/components/ModernImage";

const items = [
    {
        title: "Robynn AI",
        tag: "Agentic marketing platform",
        blurb: "Durable SSE streaming, background-execution polling, and a visual DAG canvas on Supabase + a LangGraph agent service. In production.",
        href: "/project/robynn",
        image: "/uploads/robynn-demo.jpg",
    },
    {
        title: "Handshake AI — RLE Tool Fleet",
        tag: "8 reinforcement-learning environments",
        blurb: "Deterministic simulators of enterprise software (chemical-process simulation, contract-lifecycle management, and more) — MCP tool surfaces, numerical solvers, state-integrity contracts.",
        href: "/project/handshake",
        image: null,
    },
    {
        title: "Roger Health",
        tag: "AI clinical documentation",
        blurb: "Real-time speech-to-text → multi-LLM analysis → automated document population, with foreground and background voice capture on mobile. Deployed to clinicians.",
        href: "/ai#taming-llm-output",
        image: null,
    },
];

const SelectedAiWork = () => (
    <section id="selected-ai-work" className="section bg-white">
        <div className="container-custom">
            <h2 className="section-title">Selected AI Work</h2>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                {items.map((it) => (
                    <Card key={it.title} className="flex h-full flex-col overflow-hidden transition-shadow hover:shadow-md">
                        {it.image ? (
                            <ModernImage
                                src={it.image}
                                alt={`${it.title} preview`}
                                width={480}
                                height={160}
                                className="h-40 w-full object-cover"
                                responsive={false}
                            />
                        ) : (
                            <div className="flex h-40 items-center justify-center bg-secondary/60 px-6 text-center">
                                <span className="text-sm font-medium uppercase tracking-wide text-muted-foreground">{it.tag}</span>
                            </div>
                        )}
                        <CardHeader>
                            <CardTitle className="text-lg">{it.title}</CardTitle>
                            <p className="text-xs uppercase tracking-wide text-muted-foreground">{it.tag}</p>
                        </CardHeader>
                        <CardContent className="flex flex-1 flex-col">
                            <p className="mb-4 flex-1 text-sm text-muted-foreground">{it.blurb}</p>
                            <Button variant="outline" size="sm" asChild className="w-fit">
                                <Link to={it.href} className="flex items-center gap-2">
                                    View
                                    <ArrowRight size={14} />
                                </Link>
                            </Button>
                        </CardContent>
                    </Card>
                ))}
            </div>
            <div className="mt-8 text-center">
                <Button asChild variant="ghost">
                    <Link to="/ai" className="flex items-center gap-2">
                        See the full AI dossier
                        <ArrowRight size={16} />
                    </Link>
                </Button>
            </div>
        </div>
    </section>
);

export default SelectedAiWork;
